











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ResultsHeader extends Vue {
  @Prop() private categoryName!: string;

  get capitalizedCategoryName(): string {
      return this.categoryName.charAt(0).toUpperCase() +
          this.categoryName.slice(1).toLowerCase();
  }
}
